import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './collapse.module.css.json';

var Collapse = function Collapse(props) {
  var defaultActiveKey = props.defaultActiveKey,
      accordion = props.accordion,
      className = props.className;
  var defaultValue = accordion ? [] : '';

  var _useState = useState(defaultActiveKey || defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      activeKey = _useState2[0],
      setActiveKey = _useState2[1];

  var handleToggle = function handleToggle(key) {
    setActiveKey(getNewActiveKey(activeKey, key));
  };

  var isActive = function isActive(key) {
    return accordion ? activeKey.includes(key) : key === activeKey;
  };

  var newChildren = React.Children.map(props.children, function (child, index) {
    if (child.type) {
      var itemKey = child.props.activeKey || index;
      return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({
        activeKey: index
      }, child.props), {}, {
        active: isActive(itemKey),
        onToggle: handleToggle
      }));
    }

    return child;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.Collapse, className)
  }, newChildren);
};

Collapse.defaultProps = {
  accordion: false,
  className: ''
};
Collapse.propTypes = {
  accordion: PropTypes.bool,
  // open multiple panel or only open one at a time
  defaultActiveKey: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  className: PropTypes.string
};
export default Collapse;

function getNewActiveKey(oldKey, newKey) {
  var result;

  if (!Array.isArray(oldKey)) {
    result = oldKey === newKey ? '' : newKey;
    return result;
  }

  if (oldKey.includes(newKey)) {
    result = oldKey.filter(function (item) {
      return item !== newKey;
    });
  } else {
    result = [].concat(_toConsumableArray(oldKey), [newKey]);
  }

  return result;
}